import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Icon } from '@scp/ui-shared/theme/icons';
import { Heading3 } from './typography-elements';
var IconLabelLayout = styled(Heading3)(_templateObject());
var Label = styled.span(_templateObject2());
/**
 * Component for heading with label
 *
 * @example ./__docs__/IconLabel.md
 */

export var IconLabel = function IconLabel(_a) {
  var iconName = _a.iconName,
      _a$labelAs = _a.labelAs,
      labelAs = _a$labelAs === void 0 ? Heading3 : _a$labelAs,
      children = _a.children,
      props = __rest(_a, ["iconName", "labelAs", "children"]);

  return React.createElement(IconLabelLayout, Object.assign({
    as: labelAs
  }, props), React.createElement(Icon, {
    name: iconName
  }), React.createElement(Label, null, children));
};